<y42-empty-state [header]="params.text" [body]="params.body" [iconName]="params.icon"> </y42-empty-state>
